import { render } from "./FullPageImage.vue?vue&type=template&id=04ed471b&scoped=true"
import script from "./FullPageImage.vue?vue&type=script&lang=js"
export * from "./FullPageImage.vue?vue&type=script&lang=js"

import "./FullPageImage.vue?vue&type=style&index=0&id=04ed471b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ed471b"]])

export default __exports__